import React from "react";
import { Button } from "react-bootstrap";
import { format } from 'date-fns';

import { humanize } from "../../common/utils";
import { IMMUNIZATION_STATUS } from "../utils/immunizationStatus";
import { StudentStatusIcon } from "../../School/components/StudentProfiles";

const StudentStatusBadge = ({ immunizationStatus }) => {
  const status = IMMUNIZATION_STATUS[immunizationStatus] || IMMUNIZATION_STATUS.overdue;
  const styles = status.styles;
  return (
    <span
      className="student-status-badge"
      style={{
        ...styles,
      }}>
      {humanize(immunizationStatus)}
    </span>
  );
};

const StudentImmunizationsHeader = ({
  fullName,
  immunizationStatus,
  setShownModalType,
}) => {
  return (
    <div className="mb-3 mt-5">
      <div className="d-flex justify-content-between my-3">
        <div className="d-flex align-items-center">
          <h2>{fullName}</h2>
          <StudentStatusIcon className="ms-2 mb-1" status={immunizationStatus} />
        </div>
        <div className="d-flex align-items-center">
          <span className="me-3 body-medium-normal text-muted">
            Last updated: {format(new Date(), 'hh:mm a')} (PST)
          </span>
          <StudentStatusBadge immunizationStatus={immunizationStatus} />
        </div>
      </div>
      <div className="d-flex">
        <Button
          className="me-2"
          onClick={() => setShownModalType("upload")}
          variant="outline-tertiary"
        >
          Add immunization
        </Button>
        <Button
          className="me-2"
          onClick={() => setShownModalType("exemption")}
          variant="outline-tertiary"
        >
          Add exemption
        </Button>
        <Button
          onClick={() => setShownModalType("download")}
          variant="outline-tertiary"
        >
          Download records
        </Button>
      </div>
    </div>
  );
};

export default StudentImmunizationsHeader;